import RaikoBaseContainer from "../../raikoComponents/raikoBaseContainer/RaikoBaseContainer";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import {css} from "@emotion/css";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";
import {RouteInfo} from "../../route/RouteHelper";
import React, {useState} from "react";
import ButtonSecondaryRaiko from "../../raikoComponents/raikoButtons/ButtonSecondaryRaiko";
import {useNavigate, useParams} from "react-router-dom";
import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import SpecialNewsDetailBaseInfo from "./SpecialNewsDetailBaseInfo";

const SpecialNewsDetail = () => {
    const navigate = useNavigate()
    const [tabSelectedValue, setTabSelectedValue] = useState(specialNewSDetailTabTypes.basicInformation.id)

    const {id} = useParams()

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn>
                <ButtonDivisionSection>
                    <RaikoBreadcrumb
                        className={css`flex-grow: 1`}
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                "مقالات",
                                RouteInfo.SpecialNewsList.globalUrl,
                            ),
                            raikoBreadCrumbItemGenerator(
                                "اخبار ویژه",
                                RouteInfo.SpecialNewsList.globalUrl,
                            ),
                            raikoBreadCrumbItemGenerator(
                                "جزئیات",
                                ""
                            ),
                        ]}/>
                    <ButtonSecondaryRaiko
                        label={"بازگشت"}
                        onClick={_ => {
                            navigate(RouteInfo.SpecialNewsList.globalUrl)
                        }}/>
                </ButtonDivisionSection>
                <TabContext value={tabSelectedValue}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}} className={css`
                      border-color: var(--header-border-bottom-color) !important;
                    `}>
                        <TabList id="default-tab-container" variant="scrollable">
                            <Tab icon={<div id="tabIcon" className={"ic-location"}/>} iconPosition="start"
                                 label={specialNewSDetailTabTypes.basicInformation.title}
                                 value={specialNewSDetailTabTypes.basicInformation.id}
                            />
                        </TabList>
                    </Box>
                    <TabPanel value={specialNewSDetailTabTypes.basicInformation.id}>
                        <SpecialNewsDetailBaseInfo id={id}/>
                    </TabPanel>

                </TabContext>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}
export default SpecialNewsDetail;
const specialNewSDetailTabTypes = {
    basicInformation: {
        id: "basic-information",
        title: "اطلاعات پایه"
    }
}